module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor",
    attrs: {
      "droppable": "true"
    }
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPass),
      expression: "currentPass"
    }],
    staticClass: "input password",
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.currentPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPass = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.confirmPass()
      }
    }
  }, [_vm._v("\n            Confirm\n          ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label"
  }, [_c('h3', [_vm._v("Confirm your password to access this page")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0331fcfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/login/ConfirmPassword.vue
// module id = 357
// module chunks = 66